/**
 * DocsService — the WORK space's Docs collection (`workDocs`).
 *
 * The implementation moved to docsServiceFactory.js when Docs gained a second
 * space; this file is now just the Work binding. The public API is UNCHANGED —
 * same default export, same named exports, same behaviour — so every existing
 * caller (DocsList, DocEditor) is untouched by the split.
 *
 * STAFF-ONLY, PERMANENTLY. `/workDocs` allows isEmployeeOrAdmin() on all four ops
 * with NO capability key and NO customer branch, and there never will be one: a
 * Work doc may @mention a student, but that chip is a staff-side reference and
 * grants that family nothing. Anything meant to reach a family goes through
 * Lesson Recap or Song Notes, never through a doc.
 *
 * The Personal space's equivalent is personalDocsService.js, bound to a separate
 * owner-walled collection rather than to a `space` field on this one.
 */

import { createDocsService } from './docsServiceFactory';

const DocsService = createDocsService({
	collectionName: 'workDocs',
	space: 'work',
});

// Named exports preserved so the module's public shape is exactly what it was
// before the factory split.
export const {
	subscribeToDocs,
	subscribeToDoc,
	fetchDoc,
	createDoc,
	saveDocContent,
	setDocPinned,
	duplicateDoc,
	moveDoc,
	fetchMoveTargets,
	archiveDoc,
	unarchiveDoc,
	deleteDocById,
} = DocsService;

export default DocsService;
